import React from 'react';
import { useIntl } from 'react-intl';
import type { AskUserAnswer } from '@hooks/useChat';
import { AnswersCard, AnswersHead, AnswersRow, AnswersQuestion, AnswersAnswer } from './ClarificationCard.styled';

const ClarificationAnswersSummary: React.FC<{ answers: AskUserAnswer[] }> = ({ answers }) => {
  const intl = useIntl();
  const display = (a: AskUserAnswer): string => {
    if (a.answerType === 'decide_for_me') {
      return intl.formatMessage({ id: 'chat.clarify.decide', defaultMessage: 'Decide for me' });
    }
    if (a.answerType === 'free_text') {
      return a.answer || intl.formatMessage({ id: 'chat.clarify.customAnswer', defaultMessage: 'Custom answer' });
    }
    if (a.answerType === 'region') {
      const marked = intl.formatMessage({
        id: 'chat.clarify.markedRegion',
        defaultMessage: 'Marked an area on the drawing',
      });
      return a.answer ? `${marked} — ${a.answer}` : marked;
    }
    return a.answer;
  };

  return (
    <AnswersCard>
      <AnswersHead>{intl.formatMessage({ id: 'chat.clarify.myAnswers', defaultMessage: 'My answers' })}</AnswersHead>
      {answers.map((a, i) => (
        <AnswersRow key={`${a.question}-${i}`}>
          <AnswersQuestion>{a.question}</AnswersQuestion>
          <AnswersAnswer>{display(a)}</AnswersAnswer>
        </AnswersRow>
      ))}
    </AnswersCard>
  );
};

export default ClarificationAnswersSummary;
